/**
 * Viewport tools for the front end.
 *
 * IMPORTANT: There is a separate version of this for the editor.
 */
H_Tools.viewport = (() => {
    const inViewportObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
            entry.target.setAttribute(
                'data-in-viewport',
                entry.isIntersecting ? 'true' : 'false'
            );
        });
    });

    /**
     * Adds the supplied element to be observed for whether any part of the element is in the
     * viewport.
     *
     * A `data-in-viewport` attribute is maintained for the element to reflect this.
     *
     * @param {*} el An element
     */
    function observe(el) {
        inViewportObserver.observe(el);
    }

    // Return an object to expose inner functions
    return {
        observe: observe,
    };
})();
